export { default as ArchivedBadge } from './ArchivedBadge';
export { default as AttachmentsBadge } from './AttachmentsBadge';
export { default as CheckboxFieldBadge } from './CheckboxFieldBadge';
export { default as ChecklistBadge } from './ChecklistBadge';
export { default as CommentsBadge } from './CommentsBadge';
export { default as DateFieldBadge } from './DateFieldBadge';
export { default as DescriptionBadge } from './DescriptionBadge';
export { default as DueDateBadge } from './DueDateBadge';
export { default as ListFieldBadge } from './ListFieldBadge';
export { default as NotificationBadge } from './NotificationBadge';
export { default as NumberFieldBadge } from './NumberFieldBadge';
export { default as SubscribedBadge } from './SubscribedBadge';
export { default as TextFieldBadge } from './TextFieldBadge';
export { default as TrelloAttachmentsBadge } from './TrelloAttachmentsBadge';
export { default as VotesBadge } from './VotesBadge';



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/index.js